<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.credits }}
							</h6>

							<div class="element-box-tp">

								<div class="alert" v-if="status > 200">
									<span v-if="status == 401">
										{{ t.error.access_denied_content }}
									</span>
									<span v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</span>
								</div>

								<table-component

										v-if="status == 200 && w >= 700"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="transactions"
										sort-by="id"
										sort-order="desc"
								>
									<table-column show="id" label="#" cell-class="w50"></table-column>
									<table-column show="currency.iso_code" :label="t.finance.currency" cell-class="w50"></table-column>
									<table-column :label="t.paid" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ row.paid | toMoney(row.currency) }}
										</template>
									</table-column>
									<table-column :label="t.amount" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ row.amount | toMoney(row.currency) }}
										</template>
									</table-column>
									<table-column :label="t.user.created_at" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ dateTimeFormat(row.createdAt) }}
										</template>
									</table-column>
									<table-column :label="t.expiry_date" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ dateTimeFormat(row.expiryAt) }}
										</template>
									</table-column>
									<table-column label="" :sortable="false" :filterable="false" cell-class="w50 p-0 text-center">
										<template slot-scope="row">
											<router-link :to="{name: 'userprofile', params: {id: row.user.id}}">
												<span :id="'cu_'+row.id" class="ml-2"><i class="os-icon os-icon-user-male-circle2"></i></span>
											</router-link>
											<b-popover :target="'cu_'+row.id" triggers="hover focus">
												<div class="user-with-avatar">
													<img alt="" :src="api+'api/v1/users/get/profile_pic/'+row.user.id">
													<span class="d-none d-xl-inline-block">{{ row.user.name }}</span>
												</div>
												<div class="row mt-3">
													<div class="listy b-b" v-if="row.user.online ">
														<span class="label">
															{{ t.betting.title.status }}
														</span>
														{{ t.user.online }}
													</div>
													<div class="listy b-b">
														<span class="label">
															{{ t.user.last_login }}
														</span>
														{{ row.user.lastLogin | timeAgo }}
													</div>
													<div class="listy b-b">
														<span class="label">
															{{ t.user.balance }}
														</span>
														{{ row.user.balance | toMoney(row.user.currency) }}
													</div>
												</div>
											</b-popover>
										</template>
									</table-column>
									<table-column label="" :sortable="false" :filterable="false" cell-class="w50 p-0 text-center row-actions">
										<template slot-scope="row">
											<a href="javascript:;">
												<span v-tooltip="t.get_payment" v-on:click="openPayment(row)" class="ml-2 pull-right col-12"><i class="fa fa-calculator"></i></span>
											</a>
										</template>
									</table-column>
								</table-component>

								<div class="mobile-content" v-if="w < 700">

									<div class="element-box relative" v-for="row in transactions">

										<div class="row p-0">
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														#
													</span>
													{{ row.id }}
												</div>
											</div>
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														{{ t.amount }}
													</span>
													{{ row.amount | toMoney(row.currency) }}
												</div>
											</div>
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														{{ t.createdAt }}
													</span>
													{{ dateTimeFormat(row.createdAt) }}
												</div>
											</div>
										</div>
									</div>

								</div>


								<paginate v-if="pagination"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>
							</div>
						</div>
						<!--END - User List -->
					</div>
				</div>
			</div>

			<!--------------------
START - Sidebar
-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper pt-4">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
						<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">
							<filterGenerator :filter="filter"></filterGenerator>
						</b-collapse>
					</div>
				</div>
			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="transferModal">
			<creditPayment v-if="transaction" :transaction="transaction" />
		</sweet-modal>
	</div>
</template>

<script>
    import filterGenerator from '@/components/form/filter'
    import { TableComponent, TableColumn } from 'vue-table-component'
    import creditPayment from '@/components/accounting/creditPayment'

    export default {
        name: 'credits',
        components: { 'table-component': TableComponent, 'table-column': TableColumn, filterGenerator, creditPayment},
        data () {
            return {
                api: window.api,
                w: window.innerWidth,
                isLoading: false,
                transactions: null,
                pagination: null,
                t: this.$root.t,
                status: 0,
                types: null,
                filter: {},
                transaction: null
            }
        },
        watch: {
            '$route.query' () {
                this.fetchTransactions();
            }
        },
        mounted () {
            this.fetchCurrencies();
            this.fetchTypies();
            this.filterFixture();
            this.fetchTransactions();
        },
        methods: {
            openPayment (transaction){
                this.transaction = transaction;
				this.$refs.transferModal.open()
            },
            onChangePage (page) {
                this.pagination.current = page;

                this.$route.query.page = page;
                var qr = this.$route.query;
                this.$router.push({});

                this.$router.push({ query: qr });

                this.filter.model.page = page;

                window.scroll(0, 0);
            },
	        filterNow () {
                this.$router.push({ query: this.filter.model });
	        },
            fetchTransactions () {

                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/credits?noCache=1', {params: this.$route.query }).then(response => {
                        // get body data
                        this.transactions = response.body.result.credits;
                        this.pagination = response.body.result.pagination;
                        this.isLoading = false;
                        this.status = response.status;

                    }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })


                }

            },
            filterFixture () {
                this.filter = {
                    model: {
                        page: 1,
                        uid: '',
                        username: '',
                        currencies: [],
                        types: [],
                        rangeDate: '',
                        expiryDate: '',
                        rangeAmount: {},
                        rangePaidAmount: {}
                    },
                    schema: {
                        groups: [
                            {
                                legend: 'Genel',
                                fields: [
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.user.id,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "User",
                                        label: this.t.user.username,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "AmountRange",
                                        label: this.t.amount_range,
                                        model: "rangeAmount",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "AmountRange",
                                        label: this.t.paid_amount_rang,
                                        model: "rangePaidAmount",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.created_at,
                                        model: "rangeDate",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
	                                        format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',

                                        }
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.expiry_date,
                                        model: "expiryDate",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',

                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.transaction,
                                        model: "types",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.types,
                                        checklistOptions: {
                                            value: "id",
                                            name: "info"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.finance.currency,
                                        model: "currencies",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.currencies,
                                        checklistOptions: {
                                            value: "id",
                                            name: "iso_code"
                                        }
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.filter.title,
                                        onSubmit: this.filterNow,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            },
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
            async fetchCurrencies () {
                this.$http.get(api+'api/v1/currencies')
                    .then(response => {

                        this.currencies = response.body.result.currencies;
                        this.filterFixture();
                    }, response => {

                    })
            },
            async fetchTypies () {
                this.$http.get(api+'api/v1/user/transactions/types')
                    .then(response => {

                        this.types = response.body.result;
                        this.filterFixture();
                    }, response => {

                    })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/credits.vue